import { FunctionComponent, HTMLAttributes } from 'react';

const Chevrelon: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.65077 11.7593C8.27628 12.0802 7.72368 12.0802 7.34919 11.7593L0.34919 5.75926C-0.0701357 5.39984 -0.118699 4.76854 0.240725 4.34921C0.600147 3.92988 1.23145 3.88132 1.65077 4.24074L7.99998 9.68292L14.3492 4.24074C14.7685 3.88132 15.3998 3.92988 15.7592 4.34921C16.1187 4.76853 16.0701 5.39983 15.6508 5.75926L8.65077 11.7593Z" fill="currentColor" />
  </svg>

);

export default Chevrelon;
